import { createAsyncThunk } from '@reduxjs/toolkit';
import { EditorPlatform } from '@wix/ambassador-cc-helpcenter-v1-related-document/types';
import { ArticleSearchResultItem } from '@wix/cc-user-facing-common-components';

import { MAX_ARTICLES_SEARCH_OFFSET } from '../../../constants';
import { searchArticles, SearchArticlesItem } from '../api/searchArticles';
import { HttpClientFactory } from '../httpClient';

export const loadSolutions = createAsyncThunk<
  SearchArticlesItem[] | ArticleSearchResultItem[],
  {
    query: string;
    limit: number;
    offset: number;
    filters: {
      categoriesIds?: string[];
      excludedCategoriesIds?: string[];
      editorType?: EditorPlatform;
    };
    httpClient: HttpClientFactory;
  }
>('loadSolutions', async ({ query, limit, offset, filters, httpClient }) => {
  if (offset > MAX_ARTICLES_SEARCH_OFFSET) {
    return [];
  }

  const newArticles = await searchArticles(query, limit, offset, httpClient, filters);

  return newArticles;
});
